module.exports = __webpack_public_path__ + "img/kaf_no.81a16842.png";